import React from 'react';
import { useAutomaticFontSizing } from '../lib/useAutomaticFontSizing';

interface IProps {
  width: number;
  height: number;
  value: string;
  fontFamily: string;
  fontSize: number;
  updateBlock: (updates: any) => void;
  parentRef: React.RefObject<any>;
  pageScale: number;
  blockType: string;
  dataSpec: string;
}

// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
const AutosizingBlock = (props: IProps) => {
  const textRef = React.useRef<HTMLDivElement>(null);

  const { fontSize } = useAutomaticFontSizing({
    height: props.height!,
    width: props.width!,
    initialFontSize: props.fontSize,
    initialValue: props.value,
    fontFamily: props.fontFamily,
    blockType: props.blockType,
  });

  React.useEffect(() => {
    props.updateBlock({ fontSize });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fontSize]);

  return (
    <div
      data-spec={props.dataSpec}
      ref={textRef}
      style={{
        fontSize: fontSize * props.pageScale,
        fontWeight: props.fontFamily === 'courier' ? 'bold' : 'normal',
      }}
    >
      {props.value}
    </div>
  );
};

// eslint-disable-next-line import/no-default-export -- This code was written prior to enforcing lint rules
export default AutosizingBlock;
